// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4v-2";
export var blackBorderOnHover = "_4v-7";
export var cell = "_4v-6";
export var cellContainer = "_4v-3";
export var checked = "_4v-8";
export var disabled = "_4v-5";
export var featuredIconCellContainer = "_4v-9";
export var featuredIconTextContainer = "_4v-b";
export var featuredIconWrapper = "_4v-a";
export var noBorder = "_4v-c";
export var orangeSelectedRow = "_cv-3";
export var overflowableText = "_4v-0";
export var overflowableTextContainer = "_4v-1";
export var row = "_4w-0";
export var rowCheckboxCell = "_4v-4";
export var selectableTable = "_cv-2";